const languageIncludes = (language: string, codes: string[]): boolean =>
  codes.some((code) => language.toLowerCase().includes(code.toLowerCase()));

export const getSupportSystemUrlByLanguage = (language: string): string => {
  const baseUrl = 'https://customerportal.talentech.com';

  if (!language) {
    return `${baseUrl}/knowledge`;
  }
  switch (true) {
    case languageIncludes(language, ['sv']):
      return `${baseUrl}/sv/knowledge`;
    case languageIncludes(language, ['da']):
      return `${baseUrl}/da/knowledge`;
    case languageIncludes(language, ['no', 'nb']):
      return `${baseUrl}/no-no/knowledge`;
    case languageIncludes(language, ['fi']):
      return `${baseUrl}/fi/knowledge`;
    case languageIncludes(language, ['en']):
    default:
      return `${baseUrl}/knowledge`;
  }
};
